var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAkarIconsVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9987 6.66602H9.9987C6.3168 6.66602 3.33203 9.65078 3.33203 13.3327V26.666C3.33203 30.3479 6.3168 33.3327 9.9987 33.3327H29.9987C33.6806 33.3327 36.6654 30.3479 36.6654 26.666V13.3327C36.6654 9.65078 33.6806 6.66602 29.9987 6.66602Z",
    stroke: "#040404",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9974 20L16.6641 15V25L24.9974 20Z",
    stroke: "#040404",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsVideo);
export default __webpack_public_path__ + "static/media/akar-icons_video.6134c265bd91fc436535b2d75736008c.svg";
export { ForwardRef as ReactComponent };